module.exports = __webpack_public_path__ + "static/img/noimg.1fa5b81b.jpg";